(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTabs(root) {
    if (!root || root.dataset.lvReady === 'true') return;
    root.dataset.lvReady = 'true';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-best-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-best-panel]'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.bestTab;
        tabs.forEach(function (item) {
          var selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.setAttribute('tabindex', selected ? '0' : '-1');
        });
        panels.forEach(function (panel) {
          var active = panel.dataset.bestPanel === target;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });
  }

  function initCarousel(root) {
    if (!root || root.dataset.lvReady === 'true') return;
    root.dataset.lvReady = 'true';
    var track = root.querySelector('[data-lv-track]');
    var prev = root.querySelector('[data-lv-prev]');
    var next = root.querySelector('[data-lv-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).gap || '0');
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function initHero(root) {
    if (!root || root.dataset.lvReady === 'true') return;
    root.dataset.lvReady = 'true';
    var track = root.querySelector('[data-hero-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.roma-hero__slide'));
    var dots = root.querySelector('[data-hero-dots]');
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (!track || !slides.length || !dots) return;

    slides.forEach(function (slide, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      if (index === 0) button.classList.add('is-active');
      button.addEventListener('click', function () {
        track.scrollTo({ left: track.clientWidth * index, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
      dots.appendChild(button);
    });

    function update() {
      var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      Array.prototype.forEach.call(dots.querySelectorAll('button'), function (button, dotIndex) {
        button.classList.toggle('is-active', dotIndex === index);
        button.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });

    var seconds = parseInt(root.dataset.autoplaySeconds || '0', 10);
    if (seconds > 0 && slides.length > 1 && !reduceMotion) {
      root._lvInterval = window.setInterval(function () {
        if (document.hidden) return;
        var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        track.scrollTo({ left: track.clientWidth * ((index + 1) % slides.length), behavior: 'smooth' });
      }, seconds * 1000);
    }
    update();
  }

  function initialise(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-lv-tabs]').forEach(initTabs);
    context.querySelectorAll('[data-lv-carousel]').forEach(initCarousel);
    context.querySelectorAll('[data-roma-hero]').forEach(initHero);
  }

  function destroySection(section) {
    section.querySelectorAll('[data-roma-hero]').forEach(function (root) {
      if (root._lvInterval) window.clearInterval(root._lvInterval);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  } else {
    initialise(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroySection(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest && event.target.closest('.roma-hero__slide');
    if (!slide) return;
    var root = slide.closest('[data-roma-hero]');
    var track = root && root.querySelector('[data-hero-track]');
    if (!track) return;
    track.scrollTo({ left: track.clientWidth * Number(slide.dataset.slideIndex || 0), behavior: reduceMotion ? 'auto' : 'smooth' });
  });
})();
